import styled from 'styled-components';
import React, { ReactNode } from 'react';

// TODO https://anchorfm.atlassian.net/browse/WHEEL-863: Should this max-width be a shared variable somewhere?
const MAX_PAGE_WIDTH = 1280;
const PAGE_MARGIN = 48;

const Container = styled.div`
  width: 100%;
  max-width: ${MAX_PAGE_WIDTH - PAGE_MARGIN * 2}px;
  margin: auto;
  padding: ${PAGE_MARGIN}px;
`;

type AsProp = keyof JSX.IntrinsicElements | React.ComponentType<any>;
type Props = { as?: AsProp; children?: ReactNode } & Omit<
  React.AllHTMLAttributes<any>,
  'as'
>;

export const EncoreScreenContainer = (props: Props) => {
  const { as, children } = props;
  return (
    <Container {...props} as={as}>
      {children}
    </Container>
  );
};
